import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	orders: [],
	page: 1,
	maxPage: 1,
	total: 0,
};

const orderDocsSlice = createSlice({
	name: 'orderDocs',
	initialState: initialState,
	reducers: {
		setOrderDocs: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setOrderDocs, reset } = orderDocsSlice.actions;

export default orderDocsSlice.reducer;